@if (isAnyTeamInProduct(product())) {
  @if (product()[openName()]) {
    <div class="group">
      <div
        class="group-name"
        (click)="toggleOpenPlatform(product())"
      >
        {{ platform().title }}
      </div>
      <div class="group-headers">
        <div class="column">План</div>
        <div class="column">
          <app-fact-header/>
        </div>
        <div class="column">Реалиация</div>
        @for (config of columnsConfig; track $index) {
          <div
            class="column {{ config.type }}"
            [class.collapsed-column]="!product().platforms[platform().type][config.columnType]"
          >
            <app-grouped-header-columns
              [columns]="config.columns"
              [widths]="config.widths"
              [columnName]="config.columnName"
              [isColumnOpen]="product().platforms[platform().type][config.columnType]"
              (openColumn)="handleActionsColumn({
                monthNumber: monthData().monthNumber,
                productId: product().id,
                platformType: platform().type,
                columnType: config.columnType
              })"
              (closeColumn)="handleActionsColumn({
                monthNumber: monthData().monthNumber,
                productId: product().id,
                platformType: platform().type,
                columnType: config.columnType
              })"
            />
          </div>
        }
      </div>
      <div class="teams">
        @for (team of product().teams; track team.id) {
          <div class="team">
            <div class="group-rows">
              <div class="row reviewer-row">
                <div class="column">
                  {{formatNumberValueToRubles(team.reviewerReport[platform().type]['plan'])}}
                </div>
                <div class="column">
                  <app-fact-value
                    [factValue]="formatNumberValueToRubles(team.reviewerReport[platform().type]['fact'])"
                    [published]="formatNumberValue(team.reviewerReport[platform().type]['releasedFact'])"
                    [expected]="formatNumberValue(team.reviewerReport[platform().type]['waitingFact'])"
                  />
                </div>
                <div class="column"> {{formatNumberValue(team.reviewerReport[platform().type]['realization'])}}% </div>
                <div
                  class="column actions"
                  [class.collapsed-column]="!product().platforms[platform().type].isActionsColumnOpen"
                >
                  @if (product().platforms[platform().type].isActionsColumnOpen) {
                    <app-grouped-value-columns
                      [columns]="[
                        formatNumberValue(team.reviewerReport[platform().type]['views']),
                        formatNumberValue(team.reviewerReport[platform().type]['clicks']),
                        formatNumberValue(team.reviewerReport[platform().type]['visits']),
                        formatNumberValue(team.reviewerReport[platform().type]['orders']),
                        formatNumberValue(team.reviewerReport[platform().type]['requests'])
                      ]"
                      [widths]="actionsWidths"
                    />
                  }
                </div>
                <div
                  class="column stats"
                  [class.collapsed-column]="!product().platforms[platform().type].isStatsColumnOpen"
                >
                  @if (product().platforms[platform().type].isStatsColumnOpen) {
                    <app-grouped-value-columns
                      [columns]="[
                        formatNumberValue(team.reviewerReport[platform().type]['cpv'], 2),
                        formatNumberValue(team.reviewerReport[platform().type]['cpc'], 2),
                        formatNumberValue(team.reviewerReport[platform().type]['cpa'], 2),
                        formatNumberValue(team.reviewerReport[platform().type]['cps'], 2),
                        formatNumberValue(team.reviewerReport[platform().type]['cpz'], 2)
                      ]"
                      [widths]="statsWidths"
                    />
                  }
                </div>
                <div
                  class="column results"
                  [class.collapsed-column]="!product().platforms[platform().type].isResultsColumnOpen"
                >
                  @if (product().platforms[platform().type].isResultsColumnOpen) {
                    <app-grouped-value-columns
                      [columns]="[
                        formatNumberValue(team.reviewerReport[platform().type]['averageCheck']),
                        (team.reviewerReport[platform().type]['integrationsPlan'] ?? 0) + '/' + (team.reviewerReport[platform().type]['integrationsFact'] ?? 0)
                      ]"
                      [widths]="resultsWidths"
                    />
                  }
                </div>
              </div>
              @for (managerReport of team.managerReports; track $index) {
                <div class="row">
                  <div class="column">
                    <app-update-input-number
                      [startValue]="+managerReport[platform().type]['plan']"
                      [rolesWhichCanEdit]="['ROLE_ADMIN', 'ROLE_REVIEWER']"
                      (saveValue)="updateValue({
                        managerId: managerReport.id,
                        property: propertyPlan(),
                        value: $event,
                        month: monthData().monthNumber,
                        currentProduct: product()
                      })"
                    />
                  </div>
                  <div class="column">
                    <app-fact-value
                      [factValue]="formatNumberValue(managerReport[platform().type]['fact'])"
                      [published]="formatNumberValue(managerReport[platform().type]['releasedFact'])"
                      [expected]="formatNumberValue(managerReport[platform().type]['waitingFact'])"
                    />
                  </div>
                  <div class="column"> {{formatNumberValue(managerReport[platform().type]['realization'])}}% </div>
                  <div
                    class="column actions"
                    [class.collapsed-column]="!product().platforms[platform().type].isActionsColumnOpen"
                  >
                    @if (product().platforms[platform().type].isActionsColumnOpen) {
                      <app-grouped-value-columns
                        [columns]="[
                          formatNumberValue(managerReport[platform().type]['views']),
                          formatNumberValue(managerReport[platform().type]['clicks']),
                          formatNumberValue(managerReport[platform().type]['visits']),
                          formatNumberValue(managerReport[platform().type]['orders']),
                          formatNumberValue(managerReport[platform().type]['requests'])
                        ]"
                        [widths]="actionsWidths"
                      />
                    }
                  </div>
                  <div
                    class="column stats"
                    [class.collapsed-column]="!product().platforms[platform().type].isStatsColumnOpen"
                  >
                    @if (product().platforms[platform().type].isStatsColumnOpen) {
                      <app-grouped-value-columns
                        [columns]="[
                          formatNumberValue(managerReport[platform().type]['cpv'], 2),
                          formatNumberValue(managerReport[platform().type]['cpc'], 2),
                          formatNumberValue(managerReport[platform().type]['cpa'], 2),
                          formatNumberValue(managerReport[platform().type]['cps'], 2),
                          formatNumberValue(managerReport[platform().type]['cpz'], 2)
                        ]"
                        [widths]="statsWidths"
                      />
                    }
                  </div>
                  <div
                    class="column results"
                    [class.collapsed-column]="!product().platforms[platform().type].isResultsColumnOpen"
                  >
                    @if (product().platforms[platform().type].isResultsColumnOpen) {
                      <app-grouped-value-columns
                        [columns]="[
                          formatNumberValue(team.reviewerReport['averageCheck']),
                          (managerReport[platform().type]['integrationsPlan'] ?? 0) + '/' + (managerReport[platform().type]['integrationsFact'] ?? 0)
                        ]"
                        [widths]="resultsWidths"
                        [isIntegrationsPlan]="true"
                        (updateIntegrationsPlan)="updateValue({
                          managerId: managerReport.id,
                          property: propertyIntegrationsPlan(),
                          value: $event,
                          month: monthData().monthNumber,
                          currentProduct: product()
                        })"
                      />
                    }
                  </div>
                </div>
              }
              @if (team.notAssignedManagerPlanFacts.length) {
                @for (managerReport of team.notAssignedManagerPlanFacts; track $index) {
                  <div class="row not-assigned">
                    <div class="column">
                      <app-update-input-number
                        [startValue]="+managerReport[platform().type]['plan']"
                        [rolesWhichCanEdit]="[ 'ROLE_ADMIN', 'ROLE_REVIEWER' ]"
                        [onlyReadonlyField]="true"
                        (saveValue)="updateValue({
                          managerId: managerReport.id,
                          property: propertyPlan(),
                          value: $event,
                          month: monthData().monthNumber,
                          currentProduct: product()
                        })"
                      />
                    </div>
                    <div class="column">
                      <app-fact-value
                        [factValue]="formatNumberValue(managerReport[platform().type]['fact'])"
                        [published]="formatNumberValue(managerReport[platform().type]['releasedFact'])"
                        [expected]="formatNumberValue(managerReport[platform().type]['waitingFact'])"
                      />
                    </div>
                    <div class="column"> {{formatNumberValue(managerReport[platform().type]['realization'])}}% </div>
                    <div
                      class="column actions"
                      [class.collapsed-column]="!product().platforms[platform().type].isActionsColumnOpen"
                    >
                      @if (product().platforms[platform().type].isActionsColumnOpen) {
                        <app-grouped-value-columns
                          [columns]="[
                            formatNumberValue(managerReport[platform().type]['views']),
                            formatNumberValue(managerReport[platform().type]['clicks']),
                            formatNumberValue(managerReport[platform().type]['visits']),
                            formatNumberValue(managerReport[platform().type]['orders']),
                            formatNumberValue(managerReport[platform().type]['requests'])
                          ]"
                          [widths]="actionsWidths"
                        />
                      }
                    </div>
                    <div
                      class="column stats"
                      [class.collapsed-column]="!product().platforms[platform().type].isStatsColumnOpen"
                    >
                      @if (product().platforms[platform().type].isStatsColumnOpen) {
                        <app-grouped-value-columns
                          [columns]="[
                            formatNumberValue(managerReport[platform().type]['cpv'], 2),
                            formatNumberValue(managerReport[platform().type]['cpc'], 2),
                            formatNumberValue(managerReport[platform().type]['cpa'], 2),
                            formatNumberValue(managerReport[platform().type]['cps'], 2),
                            formatNumberValue(managerReport[platform().type]['cpz'], 2)
                          ]"
                          [widths]="statsWidths"
                        />
                      }
                    </div>
                    <div
                      class="column results"
                      [class.collapsed-column]="!product().platforms[platform().type].isResultsColumnOpen"
                    >
                      @if (product().platforms[platform().type].isResultsColumnOpen) {
                        <app-grouped-value-columns
                          [columns]="[
                            formatNumberValue(team.reviewerReport['averageCheck']),
                            (managerReport[platform().type]['integrationsPlan'] ?? 0) + '/' + (managerReport[platform().type]['integrationsFact'] ?? 0)
                          ]"
                          [widths]="resultsWidths"
                          [isIntegrationsPlan]="true"
                          (updateIntegrationsPlan)="updateValue({
                            managerId: managerReport.id,
                            property: propertyIntegrationsPlan(),
                            value: $event,
                            month: monthData().monthNumber,
                            currentProduct: product()
                          })"
                        />
                      }
                    </div>
                  </div>
                }
              }
            </div>
          </div>
        }
      </div>
    </div>
  } @else {
    <div
      class="group-placeholder"
      [class]="platform().type"
      (click)="toggleOpenPlatform(product())"
    >
      {{ platform().title }}
    </div>
  }
}
